/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Interface for a plugin.
 * @author kozbial@google.com (Monica Kozbial)
 */

'use strict';

goog.provide('Blockly.IPlugin');


/**
 * The interface for a workspace plugin.
 * @interface
 */
Blockly.IPlugin = function() {};

